import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import VueBus from "vue-bus";
import Toasted from "vue-toasted";

Vue.use(VueBus);
Vue.use(Toasted, {
  iconPack: "mdi",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
